
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form11";
const form11State = namespace("Form11");

import Form11ProcessHeader from "@/components/process/Form11/components/Form11ProcessHeader.vue";
import { packageInfoType } from '@/types/Information';
import { form11StatusInfoType } from '@/types/Information/Form11';

@Component({
    components:{
        Form11ProcessHeader
    }
})
export default class SubmitForm11 extends Vue {

    @form11State.State
    public currentOrderMultipleJusticesId: string;

    stepsCompleted = {} as form11StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public savePdf(){        
        const pdfType = "FORM"
        const pdfName ="Form11"
        const url = '/form11/form-print/'+this.currentOrderMultipleJusticesId+'/?pdf_type='+pdfType
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);          

        },err => {
            console.error(err);
        });
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
